<template>
	<div>
		<div
			:class="['c-settings__overlay', { active: showSettings === true }]"
			@click="onOverlayClick"
		></div>
		<div :class="['c-settings', { active: showSettings === true }]">
			<div class="c-settings__inner">
				<div class="c-settings__header">
					<h4>Settings</h4>
				</div>
				<div class="c-settings__body">
					<FormSettings></FormSettings>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import FormSettings from '@/components/forms/settings';
export default {
	components: {
		FormSettings,
	},

	data: function () {
		return {};
	},

	computed: {
		showSettings: function () {
			return this.$store.getters['settings/showSettings'];
		},
	},

	methods: {
		onOverlayClick: function (e) {
			this.$store.dispatch('settings/hideSettings');
		},
	},

	mounted: function () {
		// setInterval(() => {
		// 	console.log(this);
		// 	this.active = !this.active;
		// }, 4000);
	},
};
</script>

<style lang="scss">
.c-settings {
	display: flex;
	justify-content: center;
	align-items: center;
	position: fixed;
	z-index: var(--z-5);
	margin: 0 auto;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;

	pointer-events: none;

	&__overlay {
		position: fixed;
		z-index: var(--z-4);
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		backdrop-filter: blur(6px);
		transition: all 300ms ease-out;
		pointer-events: all;
		opacity: 0;
		pointer-events: none;

		&.active {
			opacity: 1;
			pointer-events: all;
		}
	}

	&__inner {
		position: relative;
		width: 100%;
		max-width: 560px;
		height: 80vh;
		margin: 0 auto;
		overflow: hidden;
		background-color: var(--g4);
		border-radius: var(--border-radius-lg);
		box-shadow: 0 6.7px 5.3px rgba(0, 0, 0, 0.028),
			0 22.3px 17.9px rgba(0, 0, 0, 0.042), 0 100px 80px rgba(0, 0, 0, 0.07);
		transition: opacity 300ms ease-out 150ms,
			transform 300ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
		transform: translateY(10px) scale(0.85);
		opacity: 0;
		pointer-events: none;
	}
	&.active {
		.c-settings__inner {
			transform: translateY(0) scale(1);
			opacity: 1;
			pointer-events: all;
		}
	}

	&__header {
		display: flex;
		align-items: center;
		justify-content: center;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: var(--spacer);
		padding: var(--margin) var(--spacer-sm);
		background-color: var(--g1);
		border-bottom: rgba(0, 0, 0, 0.05) solid 1px;

		h4 {
			margin: 0;
			opacity: 0.75;
		}
	}

	&__body {
		margin-top: var(--spacer);
		height: 100%;
		padding: var(--spacer-sm);
		overflow-y: auto;
	}
}
</style>